export default "__VITE_ASSET__BZailYPZ__"